import React, { useContext } from 'react';

import SideFilterSection from './SideFilterSection';

function SideFilters(props){
    const {
        form,
        } = props;

     
    return (
        <>
            
            {form.map((form_section) => {
                if (form_section.type == "checkboxes" || form_section.type == "date"){
                    return <SideFilterSection key={`key-${form_section.name}`} data={form_section}/>
                }
            }
                
            )}
   
          
        </>
    )
}

export default SideFilters;